import URLSearchParams from '@ungap/url-search-params';

export default () => {
  const search = (window && window.location && window.location.search) || '';

  return Array.from(new URLSearchParams(search).entries())
    .reduce((memo, [key, value]) => Object.assign(memo, { [key]: value }), {});
};
